export const buildStatsigCustom = ({
  isCountryCompliant,
  forcedBuckets,
  consentCookieValue,
}: {
  isCountryCompliant: boolean
  forcedBuckets: Record<string, string | string[]>
  consentCookieValue: string | undefined
}): Record<string, string | string[] | boolean> => {
  if (!isCountryCompliant) return forcedBuckets
  return { ...forcedBuckets, hasConsented: consentCookieValue === 'true' }
}
